import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { Global } from "src/app/global";
import { ApiService } from "src/app/service/apiServices";
import Swal from "sweetalert2";

@Component({
  selector: "app-modal-laudo-lme",
  templateUrl: "./modal-laudo-lme.component.html",
  styleUrls: ["./modal-laudo-lme.component.css"],
})
export class ModalLaudoLmeComponent implements OnInit {
  @Input() atendimentoId: any;
  @Input() presencaId: any;
  @Input() cidadaoId: any;
  formulario: FormGroup;
  cidadao: any = {};
  decimalFormat: RegExp = new RegExp(/^\d+(\.\d{0,2})?$/g);
  public onClose: Subject<boolean> = new Subject();

  constructor(
    public global: Global,
    public service: ApiService,
    public bsModalRef: BsModalRef
  ) {}

  ngOnInit() {
    this.obterAtendimento();
    this.iniciarFormulario();
  }

  adicionarPrescricao() {
    this.prescricoes.push(this.novaPrescricao());
  }
  iniciarFormulario() {
    this.formulario = new FormGroup({
      presenca_id: new FormControl(this.presencaId),
      cidadao_id: new FormControl(this.cidadaoId),
      atendimento_id: new FormControl(this.atendimentoId),
      cidadao_nome_completo: new FormControl("", [
        Validators.required,
        Validators.minLength(3),
      ]),
      cidadao_nome_mae: new FormControl("", [
        Validators.required,
        Validators.minLength(3),
      ]),
      cidadao_email: new FormControl("", [
        Validators.required,
        Validators.minLength(3),
        Validators.email,
      ]),
      cidadao_peso: new FormControl("", [
        Validators.required,
        Validators.pattern(/^\d+(\.\d{1,2})?$/),
      ]),
      cidadao_altura: new FormControl("", [
        Validators.required,
        Validators.pattern(/^\d+(\.\d{1,2})?$/),
      ]),
      cidadao_incapaz: new FormControl(false, [Validators.required]),
      cidadao_nome_responsavel: new FormControl("", [Validators.minLength(3)]),
      cidadao_raca_cor_etnia: new FormControl("", [Validators.required]),
      cidadao_etnia_nome: new FormControl("", [Validators.minLength(3)]),
      estabelecimento_cnes: new FormControl("", [
        Validators.required,
        Validators.minLength(3),
      ]),
      estabelecimento_solicitante_nome: new FormControl("", [
        Validators.minLength(3),
      ]),
      cid10: new FormControl("", [
        Validators.required,
        Validators.minLength(3),
      ]),
      diagnostico: new FormControl("", [Validators.minLength(3)]),
      anamnese: new FormControl("", [
        Validators.required,
        Validators.minLength(3),
      ]),
      cidadao_realizou_tratamento_previo: new FormControl(false, [
        Validators.required,
      ]),
      relato_tratamento_previo: new FormControl("", [Validators.minLength(3)]),
      profissional_solicitante_nome: new FormControl("", [
        Validators.required,
        Validators.minLength(3),
      ]),
      profissional_solicitante_cns: new FormControl("", [
        Validators.required,
        Validators.minLength(3),
      ]),
      data_solicitacao: new FormControl("", [Validators.required]),
      prescricoes: new FormArray([]),
    });
  }

  obterAtendimento() {
    this.service
      .Get(`Atendimento/${this.atendimentoId}`)
      .then((res: any) => {
        this.formulario.patchValue({
          cidadao_nome_completo: res.cidadao_nome,
          cidadao_nome_mae: res.cidadao_nome_mae,
          estabelecimento_cnes: res.estabelecimento_cnes,
          estabelecimento_solicitante_nome: res.estabelecimento_nome,
          profissional_solicitante_nome: res.presenca_profissional_nome,
          profissional_solicitante_cns: res.presenca_profissional_cns,
          data_solicitacao: this.global.getDataLocalISO(),
        });
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao buscar os dados do atendimento.",
          icon: "error",
        });
      });
  }

  obterCidadao() {
    this.service
      .Get(`Cidadao/${this.cidadaoId}`)
      .then((res: any) => {
        this.cidadao = res;
        this.formulario.patchValue({
          cidadao_nome_completo: this.cidadao.nome,
          cidadao_nome_mae: this.cidadao.nome_mae,
        });
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao buscar os dados do cidadão.",
          icon: "error",
        });
      });
  }

  novaPrescricao(): FormGroup {
    return new FormGroup({
      medicamento_id: new FormControl(null),
      nome_medicamento: new FormControl("", Validators.required),
      quantidade1_mes: new FormControl("", Validators.required),
      quantidade2_meses: new FormControl(null),
      quantidade3_meses: new FormControl(null),
      quantidade4_meses: new FormControl(null),
      quantidade5_meses: new FormControl(null),
      quantidade6_meses: new FormControl(null),
    });
  }

  get prescricoes(): FormArray {
    return this.formulario.get("prescricoes") as FormArray;
  }

  removerPrescricao(index: number) {
    this.prescricoes.removeAt(index);
  }

  selecionarCid(event?: any): void {
    (this.formulario.get("cid10") as FormControl).setValue(
      event ? event.nome : ""
    );
  }

  selecionarMedicamento(event?: any, index?: number): void {
    if (!event || !event.id) {
      return;
    }
    let _medicamento = this.prescricoes.at(index) as FormGroup;

    _medicamento.get("medicamento_id").setValue(event.id);
    _medicamento.get("nome_medicamento").setValue(event.principio_ativo || "");
  }

  onSubmit() {

    if(this.prescricoes.length === 0) {
      Swal.fire({
        title: "Erro!",
        text: "É necessário adicionar pelo menos um medicamento.",
        icon: "error",
      });
      return;
    }
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    if (this.formulario.valid) {
      this.service.Post(`LaudoLme`, this.formulario.value).then(
        (result) => {
          Swal.close();
          Swal.fire({
            title: "Sucesso!",
            text: "Laudo LME salvo com sucesso.",
            icon: "success",
          }).then(() => {
            this.onClose.next(true);
            this.bsModalRef.hide();
          });
        },
        (error) => {
          Swal.close();
          Swal.fire({
            title: "Erro!",
            text: error.error.messagem || "Erro ao salvar o laudo LME.",
            icon: "error",
          });
        }
      );
    } else {
      Swal.close();
      Swal.fire({
        title: "Erro!",
        text: "Favor preencher todos os campos.",
        icon: "error",
      });
    }
  }
}
